import axios from 'axios'

export const apiUrl = process.env.REACT_APP_API_URL || ''
export const version = process.env.REACT_APP_VERSION || 'unknown'

export const httpProxy = axios.create({
  baseURL: `${apiUrl}/api/v1/`,
  timeout: 45000,
})

/**
 * Drops empty-valued query parameters, so an unset filter is omitted rather than sent as `?key=`.
 *
 * Lives here rather than alongside either API client because both use it: the public client importing it
 * from `BorrowerApiClient` created a cycle — the authenticated client imports the auth session, which
 * builds itself from the public client — and the cycle crashed at module load (`Cannot access
 * 'AxiosBorrowerPublicApi' before initialization`).
 */
export function filterEmptyParams(searchParams: URLSearchParams | null): URLSearchParams | null {
  if (searchParams === null) {
    return null
  }

  const keysForDel: string[] = []
  searchParams.forEach((value, key) => {
    if (value === '') {
      keysForDel.push(key)
    }
  })
  keysForDel.forEach((key) => searchParams.delete(key))

  return searchParams
}
